import React from 'react';
import { Link } from 'react-router-dom';
import SupervisorLayout from '../../components/SupervisorLayout';
import { useSupervisorAuth } from '../../context/SupervisorAuthContext';
import './SupervisorReportsPage.css';

// Memes 12 rapports que le dropdown "Rapports" du nav (SupervisorLayout.jsx)
// et que ReportsPage.jsx (company, memes icones) — redondance volontaire, la
// grille et le nav menent aux memes pages. Gates par SupervisorMenuPermission
// (2026-09-17) — un item non accorde par la company n'apparait pas.
const reportItems = [
  { label: 'Rapport general', icon: '📈', path: '/supervisor/general-report' },
  { label: 'Liste des ventes', icon: '📋', path: '/supervisor/sales-list' },
  { label: 'Numeros gagnants', icon: '🔄', path: '/supervisor/winning-numbers' },
  { label: 'Tickets Gagnant', icon: '🎫', path: '/supervisor/winning-tickets' },
  { label: 'Resume accumule', icon: '📊', path: '/supervisor/accumulated-summary' },
  { label: 'Cumul detaille', icon: '📊', path: '/supervisor/cumul-detaille' },
  { label: 'Tickets Vendus', icon: '🎫', path: '/supervisor/tickets-vendus' },
  { label: 'Tickets Annulaient', icon: '🚫', path: '/supervisor/tickets-annules' },
  { label: 'Resume de la Banque-Lottery', icon: '🏦', path: '/supervisor/resume-banque-lottery' },
  { label: 'Paris gagnants', icon: '🔄', path: '/supervisor/prized-numbers' },
  { label: 'Rapport du Terminal', icon: '🖥️', path: '/supervisor/terminal-report' },
  { label: 'Rapport du Banque', icon: '🏦', path: '/supervisor/bank-report' },
];

const SupervisorReportsPage = () => {
  const { supervisor } = useSupervisorAuth();
  const granted = new Set(supervisor?.menu_keys || []);
  const visibleItems = reportItems.filter((item) => granted.has(item.path));

  return (
    <SupervisorLayout>
      <p className="svrp-breadcrumb">
        Ruta : <Link to="/supervisor/dashboard" className="svrp-link">Menu</Link>
        {' >> '}
        <Link to="/supervisor/rapports" className="svrp-link">Rapports</Link>
      </p>

      <div className="svrp-grid">
        {visibleItems.map((item) => (
          <Link key={item.label} to={item.path} className="svrp-item">
            <div className="svrp-icon">{item.icon}</div>
            <span className="svrp-label">{item.label}</span>
          </Link>
        ))}
      </div>
    </SupervisorLayout>
  );
};

export default SupervisorReportsPage;
